import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqData } from '../data/mockData';

const FAQ = () => {
  return (
    <section id="faq" className="section-padding bg-[#0a0a0a]">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Header */}
          <div className="lg:sticky lg:top-32 lg:self-start">
            <span className="inline-block text-sm font-medium text-[#c9a962] tracking-wider uppercase mb-4">
              FAQ
            </span>
            
            <h2 className="heading-1 text-white mb-6">
              Common Questions
            </h2>
            
            <p className="body-large text-[#b3b3b3] mb-8">
              Everything you need to know about working with me. Can't find what you're looking for?
            </p>
            
            <a 
              href="#contact" 
              className="inline-flex items-center text-sm font-medium text-[#c9a962] underline underline-offset-4 hover:no-underline"
            >
              Get in touch for more details
            </a>
          </div>
          
          {/* Accordion */}
          <div>
            <Accordion type="single" collapsible className="w-full">
              {faqData.map((item, index) => (
                <AccordionItem 
                  key={item.id} 
                  value={`item-${item.id}`}
                  className="border-b border-[#2a2a2a] py-2"
                >
                  <AccordionTrigger className="text-left heading-3 text-white hover:text-[#c9a962] hover:no-underline py-4 [&[data-state=open]>svg]:rotate-180 [&>svg]:text-[#c9a962]">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="body-regular text-[#b3b3b3] pb-4">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
